import { Component, OnInit } from '@angular/core';
import { LiftModuleDetail } from '../../models/lift-module-detail.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { LiftModuleService } from '../../services/lift-module.service';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { NotificationType } from 'src/app/core/models/ui-notification.model';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';

@Component({
  selector: 'app-lift-module-detail',
  templateUrl: './lift-module-detail.component.html',
  styleUrls: ['./lift-module-detail.component.css']
})
export class LiftModuleDetailComponent implements OnInit {
  form = new FormGroup({});
  liftModule: LiftModuleDetail;

  constructor(
    private route: ActivatedRoute,
    private liftModuleService: LiftModuleService,
    private entityListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.liftModule = this.route.snapshot.data.liftModule;
    this.form.addControl('code', new FormControl(this.liftModule.code, Validators.required));
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {
    console.log(this.form.valid);
    if (this.form.valid) {
      this.liftModuleService.update({
        id: this.liftModule.id,
        code: this.form.get('code').value
      }).subscribe(() => {
        this.entityListRefresh.refresh('lift-module');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Modul byl aktualizován'
        });
        modal.closeModal(null);
      });
    }
  }

}
